<template>
  <div id="gb">
    <div class="lke-bg" :style="{ minHeight: minHeight + 'px' }">
      <header id="header">
        <div class="lke-header" v-if="roles === 'notEnrolled'">
          准考证号: <span>{{ userInfo.uid }}</span>
        </div>
        <div class="lke-header" v-else>
          准考证号: <span>{{ userInfo.sid }}</span>
        </div>
        <div class="lke-header">
          姓名: <span>{{ userInfo.name }}</span>
        </div>
      </header>
      <div class="lke-title-fot">
        <div class="lke-title">
          {{ name }}
        </div>
        <div style="padding-bottom:10px">
          本次考试得{{ scoreSum }}分
        </div>
        试卷已提交，请返回课程页查看最新考试状态。
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/modules/apicloud";
import moment from "moment";
export default {
  name: "",
  data() {
    return {
      minHeight: 100,
      name: "",
      scoreSum: 0,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    roles() {
      return this.$store.state.roles;
    },
  },
  created() {
    this.scoreSum = this.GetQueryValue("scoreSum");
    this.name = this.$route.params.id;
    this.minHeight = window.innerHeight;
  },
  mounted() {},
  filters: {},
  watch: {},
  methods: {
    GetQueryValue(queryName) {
      let query = window.location.href.split("?")[1];
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == queryName) {
          return pair[1];
        }
      }
      return null;
    },
  },
};
</script>

<style>
</style>

<style scoped>
.lke-bg {
  width: 994px;
  padding: 0 15px;
  background: #fff;
  margin: 0 auto;
}
#header {
  padding: 15px 30px;
}
.lke-header {
  padding-bottom: 10px;
  font-size: 20px;
  letter-spacing: 2px;
}
.lke-header > span {
  font-weight: normal;
}
.lke-title {
  text-align: center;
  font-size: 18px;
  letter-spacing: 1px;
  font-weight: 600;
  padding-bottom: 15px;
  padding-top: 50px;
}
.lke-title-fot {
  font-size: 18px;
  padding: 50px;
  border: 1px solid #ccc;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.3);
  background: #fffff7;
  margin-bottom: 15px;
  text-align: center;
}
.lke-title-fot > span {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/examination/examinationResults.vue